import { render, staticRenderFns } from "./AddFolderAction.vue?vue&type=template&id=701fec6e"
import script from "./AddFolderAction.vue?vue&type=script&lang=js"
export * from "./AddFolderAction.vue?vue&type=script&lang=js"
import style0 from "./AddFolderAction.vue?vue&type=style&index=0&id=701fec6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports